module.exports = __webpack_public_path__ + "static/img/14000441.5906f33a.png";